import {LoginTypes} from './types';
import {Auth} from '../../../models/Auth'
import {action} from 'typesafe-actions';

export const loggingIn = (data: Auth) => action(LoginTypes.LOGGING_IN, data); 

export const loggingOff = () => action(LoginTypes.LOGGING_OFF);

export const retrieving = () => action(LoginTypes.LOGGING_RETRIEVING);
